import React from "react";
import { withNavBars } from "../../HOCs";
import CreateContact from "./createContact";

class CreateContactParent extends React.Component {
    render() {
        return <CreateContact />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(CreateContactParent, props);